<template>
    <TriggerTextFieldWithEdit v-model="resultRow.description"
                              :api="`/api/triggers/${resultRow.id}`"
                              field="description"
    />
</template>

<script>
import TriggerTextFieldWithEdit from "@/views/Triggers/FrontendFilterEventResultColumnValues/TriggerTextFieldWithEdit.vue";

export default {
    name: "TriggerDescription",
    components: {TriggerTextFieldWithEdit},

    props: {
        resultRow: {required: true},
    },
}
</script>
